export default "__VITE_ASSET__Cvyjlw9d__"